module.exports = __webpack_public_path__ + "static/media/calc.1b80fa40.png";